import axios from 'axios'

const accountingSeatPublish =  async function(id){
    try{
        const   path = `/acc_accounting_seat/${id}/publish`
            ,   route = process.env.VUE_APP_API_ROUTE.concat( path )
            ,   response = await axios.post(route)
        return response.data
    }
    catch( error ) {
        return error.response.data
    }
}

export { accountingSeatPublish }
